/**
 * Temas contextuales por modo (UI chrome, fondos, acentos de control).
 * Los colores de grados en pentagrama/mástil son fijos (pedagogía) — ver scaleModuleTheme PEDAGOGICAL_DEGREE_HEX.
 */

export const CONTEXTUAL_BG_BASE = "#0d0d0d";

export interface ContextualTheme {
  key: string;
  accent: string;
  accentHover: string;
  /** Tinte radial suave encima del fondo base */
  tint: string;
  /** Segundo tinte para capas SVG / vignette */
  tint2: string;
}

const DEFAULT_THEME: ContextualTheme = {
  key: "default",
  accent: "#A1A1AA",
  accentHover: "#D4D4D8",
  tint: "rgba(255, 255, 255, 0.06)",
  tint2: "rgba(255, 255, 255, 0.03)",
};

const THEMES: Record<string, ContextualTheme> = {
  scales: {
    key: "scales",
    accent: "#FF4D4D",
    accentHover: "#E54444",
    tint: "rgba(255, 77, 77, 0.16)",
    tint2: "rgba(255, 77, 77, 0.08)",
  },
  modos: {
    key: "modos",
    accent: "#2DD4BF",
    accentHover: "#5EEAD4",
    tint: "rgba(45, 212, 191, 0.14)",
    tint2: "rgba(45, 212, 191, 0.07)",
  },
  chords: {
    key: "chords",
    accent: "#F59E0B",
    accentHover: "#D97706",
    tint: "rgba(245, 158, 11, 0.14)",
    tint2: "rgba(245, 158, 11, 0.07)",
  },
  songbook: {
    key: "songbook",
    accent: "#6366F1",
    accentHover: "#4F46E5",
    tint: "rgba(99, 102, 241, 0.14)",
    tint2: "rgba(99, 102, 241, 0.07)",
  },
  notas: {
    key: "notas",
    accent: "#22C55E",
    accentHover: "#16A34A",
    tint: "rgba(34, 197, 94, 0.12)",
    tint2: "rgba(34, 197, 94, 0.06)",
  },
  melodies: {
    key: "melodies",
    accent: "#8B5CF6",
    accentHover: "#7C3AED",
    tint: "rgba(139, 92, 246, 0.14)",
    tint2: "rgba(139, 92, 246, 0.07)",
  },
  fingers: {
    key: "fingers",
    accent: "#EC4899",
    accentHover: "#DB2777",
    tint: "rgba(236, 72, 153, 0.14)",
    tint2: "rgba(236, 72, 153, 0.07)",
  },
};

/** Alinea ids de Workbench (p. ej. songs) con la familia de tema. */
export function normalizeModuleForTheme(moduleId: string): string {
  if (moduleId === "songs") return "songbook";
  if (THEMES[moduleId]) return moduleId;
  return "default";
}

export function getContextualThemeForModule(moduleId: string): ContextualTheme {
  const k = normalizeModuleForTheme(moduleId);
  return THEMES[k] ?? DEFAULT_THEME;
}

/** Primer segmento de ruta → tema (backdrop sin depender del Workbench). */
export function pathSegmentToThemeKey(segment: string): string {
  const s = segment.toLowerCase();
  if (s === "songs" || s === "songbook") return "songbook";
  if (THEMES[s]) return s;
  return "default";
}
